import React from 'react'
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faVideo} from "@fortawesome/free-solid-svg-icons";
import styled from "@emotion/styled";
import sv from "../../styles/styles";
import {history} from "../../_helpers";

// STYLE ##########################################################

const BaseWrapper = styled(`div`)`
  ${sv.flexColumn};
  flex: 1;
  padding: 0 48px;
  height: 100%;
  align-items: center;
`;

const ContentWrapper = styled(`div`)`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative; 
  max-width: 440px;
`;

const Title = styled(`div`)`
  ${sv.title};
  color: ${sv.colors.dark};
  margin: 40px 15px;
  text-align: center;
`;

const Message = styled('div')`
    text-align: center;
    margin-bottom: 20px;
`;

const RegularButton = styled('div')`
  ${sv.buttonBase};
  ${sv.flexColumn};
  width: 100%;
  max-width: 300px;
  min-height: 100px;
  height: auto;
  padding: 5px;
  margin: 20px;
  text-align: center;
  border: ${'1px solid ' + sv.colors.cta};
  color: ${sv.colors.cta};
`;

const ButtonIcon = styled('div')`
  margin-top: 20px;
  ${sv.flexCenter};
`;

const Help = styled('div')``;

const HelpHeader = styled('div')`
  ${sv.h3};
  text-align: center;
  margin: 20px;
`;

const HelpEmail = styled('div')`
  text-align: center;
  margin: 10px;
  a {
    color: ${sv.colors.dark}
  }
`;

const HelpEmailLabel = styled('span')``;

const HelpNote = styled(HelpEmail)``;

// COMPONENT ##########################################################

export function MediaBase() {

    const {t} = useTranslation("welcome");

    return (
        <BaseWrapper>

            <ContentWrapper>
                <Title>{t("Welcome to Gistify.")}</Title>
                <Message>{t("Congratulations! You can now Gistify your content whether it be meetings, lectures, training videos, or any other recordings.")}</Message>

                {/* link to order */}
                <RegularButton onClick={() => history.push("/order")}>
                    {t("Create your first Gist")}
                    <ButtonIcon>
                        <FontAwesomeIcon icon={faVideo} size="2x"/>
                    </ButtonIcon>
                </RegularButton>

                {/* TODO: Guided Tour Video once it has been created */}

                <Help>
                    <HelpHeader>{t("Have any questions or feedback on Gistify?")}</HelpHeader>
                    <HelpEmail>
                        <HelpEmailLabel>{t("Please email")}: </HelpEmailLabel>
                        <a href="mailto:hello@gistify.ai">hello@gistify.ai</a>
                    </HelpEmail>
                    <HelpNote>{t("We always want to hear how we can improve your experience.")}</HelpNote>
                </Help>
            </ContentWrapper>

        </BaseWrapper>
    )
}